export { RegulatedFinancialServicesPage as default } from "@nvb/ui";
